export default class LoginDto {
    email;
    password;
}
